import React from 'react'
import { Typography, useTheme } from '@mui/material'

import {
  PROGRAM_TERMS_URL,
  CASH_PROGRAM_TERMS_URL,
  MERCHANT_LIST_URL
} from './types'

export const ApplicationReadyDisclaimer: React.FC = () => {
  const theme = useTheme()

  return (
    <div
      style={{
        paddingLeft: '10px',
        paddingRight: '10px'
      }}
    >
      <Typography component="p" variant="caption" sx={{ mb: theme.spacing(1) }}>
        <sup>1</sup>Paceline Cardholders earn 1.5% cash back on qualifying
        purchases and 2.5% on qualifying Health & Wellness purchases. Achieving
        your weekly Paceline Streak will double your cash back for that week to
        3% and 5% respectively. See your{' '}
        <a href={PROGRAM_TERMS_URL} target="_blank" rel="noopener noreferrer">
          Paceline Rewards Program Terms Agreement
        </a>{' '}
        for explanation and details about the Paceline Streak. See{' '}
        <a
          href={CASH_PROGRAM_TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Paceline Cash Rewards Program Terms and Conditions
        </a>{' '}
        for additional details.
      </Typography>
      <Typography component="p" variant="caption" sx={{ mb: theme.spacing(1) }}>
        A qualifying Health & Wellness purchase is based on merchant category
        codes (MCC), and in the case of{' '}
        <a href={MERCHANT_LIST_URL} target="_blank" rel="noopener noreferrer">
          merchant specific rewards
        </a>
        , on the merchant name provided to us, by the merchant's credit card
        processor. Purchases made through third-party payment accounts, mobile
        or wireless card readers, mobile or digital wallets or similar
        technology may not be eligible for Health & Wellness rewards. Paceline
        makes every effort to include all relevant merchants in its Health &
        Wellness rewards categories. However, some merchants may not be
        classified in a particular category based on their classification with
        their credit card processor. If this occurs, purchases with that
        merchant will not qualify for Health & Wellness rewards.
      </Typography>
      <Typography component="p" variant="caption" sx={{ mb: theme.spacing(1) }}>
        <sup>2</sup>You will be charged the annual membership fee once the
        account is opened, and each year thereafter.{' '}
        <a href={PROGRAM_TERMS_URL} target="_blank" rel="noopener noreferrer">
          Terms and conditions apply
        </a>
        .
      </Typography>
      <Typography component="p" variant="caption" sx={{ mb: theme.spacing(1) }}>
        By tapping on the "Accept Offer" button we will notify the credit
        reporting agencies that you were approved for the Paceline card. A hard
        inquiry will appear on your credit report which may impact your credit
        score. See the full{' '}
        <a href={PROGRAM_TERMS_URL} target="_blank" rel="noopener noreferrer">
          Terms and Conditions
        </a>{' '}
        for additional information.
      </Typography>
    </div>
  )
}
